export function sliderTemoignage(){
	let tems = jQuery(".temoignages-slider");
	tems.slick({
		arrows: false
	});
	
	jQuery(".temoignages-slider-nav").on("click", ".nav-left", (e) => {
		e.preventDefault();
		tems.slick('slickPrev');
	});
	jQuery(".temoignages-slider-nav").on("click", ".nav-right", (e) => {
		e.preventDefault();
		tems.slick('slickNext');
	});	
}